import ErrorFallback from "./components/ErrorFallback/ErrorFallback";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import { AuthenticationGuard } from "./components/authentication/AuthenticationGuard/AuthenticationGuard";
import { AuthenticationProvider } from "./components/authentication/AuthenticationProvider/AuthenticationProvider";
import { sentryCreateBrowserRouter } from "./config/sentry";
import ErrorRoute from "./routes/ErrorRoute";
import LogoutRoute from "./routes/auth/LogoutRoute";
import App from "@app/components/App/App";
import { lazyRetry } from "@lib/common/utils/lazyRetry";
import { ErrorBoundary } from "react-error-boundary";

const HomeRoute = lazyRetry(() => import("./routes/home/HomeRoute"));
const AuthErrorRoute = lazyRetry(() => import("./routes/auth/AuthErrorRoute"));

export const router = sentryCreateBrowserRouter([
  {
    path: "/auth-error",
    element: <AuthErrorRoute />
  },
  {
    path: "/",
    element: (
      <AuthenticationProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <AuthenticationGuard component={App} />
        </ErrorBoundary>
      </AuthenticationProvider>
    ),
    errorElement: <ErrorRoute />,
    children: [
      { index: true, element: <HomeRoute /> },
      // login is handled within the authentication guard and then redirected to "/" on success
      { path: "login", element: <></> },
      { path: "logout", element: <LogoutRoute /> },
      { path: "*", element: <PageNotFound /> }
    ]
  }
]);
